import React from 'react';
import './Footer.css';


function Footer() {
  return (
    <footer className="site-footer">
      <div className="footer-inner">
        {/* Column 1 - Brand & Copyright */}
        <div className="footer-column">
          <h4>Crystal Drops</h4>
          <p>© {new Date().getFullYear()} Crystal Drops</p>
          <p>Delivering water & environmental solutions with precision.</p>

            {/* Decade Achievement Badge Image */}
          <div className="footer-badge">
            <img src="/images/badge.png" alt="10 Years of Excellence" />
          </div>
        </div>

        {/* Column 2 - Quick Links */}
        <div className="footer-column">
          <h4>Quick Links</h4>
          <nav aria-label="Quick Links">
            <ul>
              <li><a href="/">Home</a></li>
              <li><a href="/about">About</a></li>
              <li><a href="/services">Services</a></li>
              <li><a href="/gallery">Gallery</a></li>
              <li><a href="/contact">Contact</a></li>
            </ul>
          </nav>
        </div>

        {/* Column 3 - Business Verticals */}
        <div className="footer-column">
          <h4>Business Verticals</h4>
          <ul>
            <li><a href="/WTP">Water Treatment Plant</a></li>
            <li><a href="/STP">Sewage Treatment Plant</a></li>
            <li><a href="/ETP">Effluent Treatment Plant</a></li>
            <li><a href="/UF">Ultra Filtration</a></li>
            <li><a href="/RO">Reverse Osmosis Plant</a></li>
          </ul>
        </div>

        {/* Column 4 - Socials */}
        <div className="footer-column socials">
          <h4>Connect With Us</h4>
          <ul className="footer-social">
            <li><a href="https://facebook.com" target="_blank" rel="noopener noreferrer">Facebook</a></li>
            <li><a href="https://instagram.com" target="_blank" rel="noopener noreferrer">Instagram</a></li>
            <li><a href="https://linkedin.com" target="_blank" rel="noopener noreferrer">LinkedIn</a></li>
          </ul>
        </div>
      </div>

      {/* Bottom bar */}
      <div className="footer-bottom">
        <nav aria-label="Legal Links" className="footer-legal">
          <a href="/privacy">Privacy</a>
          <a href="/terms">Terms</a>
          <a href="/contact">Contact</a>
        </nav>

        <a href="https://pelicaninfotech.com" target="_blank" rel="noopener noreferrer" className="powered-by-link">
          <div className="powered-by">
          <span>Powered by</span>
          <img src="/images/pelican.png" alt="Pelican Infotech" className="powered-logo" />
        </div>
        </a>
      
      </div>
    </footer>
  );
}

export default Footer;